"use client";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import Image from "next/image";
import React, { useCallback, useEffect, useMemo, useState } from "react";
// import CountDown from "./CountDown";
import { ClaimData, ResponseObject } from "@/app/classes/main";
import { ApiService } from "@/app/services/AppService";
import "./index.css";
import { getToken } from "@/app/services/HolderService";
import { getHubId } from "../../components/genericComponents/helper-functions/currencyCode.js";
import { useCurrencyCode } from "../genericComponents/helper-functions/CurrencySymbol";
import Login from "../login/Login";
import { AddToCartService } from "@/app/services/cart";
import ClaimServiceAlert from "./ClaimServiceAlert";
import Cookies from "js-cookie";
import { trackEvent } from "@/app/utils/branch";
const CountDown = React.lazy(() => import("./CountDown"));

interface claimServiceProps {
  claimService: ClaimData;
}

export const ClaimServices: React.FC<claimServiceProps> = ({
  claimService,
}) => {
  const currencyCode = useCurrencyCode();
  const apiService = useMemo(() => new ApiService(), []);
  const [claimData, setClaimData] = useState<ClaimData | undefined>(
    claimService
  );
  const [showRemoveCart, setShowRemoveCart] = useState<
    { id: any; inCart: boolean }[] | undefined
  >(undefined);
  const [showLoginBox, setShowLoginBox] = useState(false);
  const [showClaimMessage, setShowClaimMessage] = useState(false);
  const [updateClaimService, setUpdateClaimService] = useState(false);
  const token = getToken();
  const xHubId = getHubId();
  const addToCartService = new AddToCartService();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => trackEvent("HOME", null), []);

  useEffect(() => {
    const claimServiceAvailiableInLocal = localStorage.getItem("claimService");
    if (!claimServiceAvailiableInLocal) {
      const initialShowRemoveCart = claimData?.servicesList?.map(
        (service: any) => ({
          id: service.id,
          inCart: false,
        })
      );
      setShowRemoveCart(initialShowRemoveCart);
    } else {
      const claimServiceBool = JSON.parse(
        atob(localStorage.getItem("claimService") as string)
      );
      setShowRemoveCart(claimServiceBool);
    }
  }, [claimData]);

  const handleTimer = async (item: any, index: any) => {
    if (token) {
      try {
        const payload = {
          claimServiceId: item.cid.toString(),
          serviceId: item.id,
        };
        await apiService.post<ResponseObject>(
          apiService.claimFreeService +
            "?claimServiceId=" +
            payload.claimServiceId +
            "&serviceId=" +
            payload.serviceId,
          payload,
          getToken()!
        );
        setUpdateClaimService(true);
      } catch (error) {
        console.log("Error :", error);
      }
    } else {
      setShowLoginBox(true);
    }
  };

  const handleAddToCart = async (item: any) => {
    try {
      const payload = {
        claimId: item.cid.toString(),
        claimServiceValidateRequestItems: [
          {
            serviceId: item.id,
          },
        ],
      };
      const responseObject = await apiService.post<ResponseObject>(
        apiService.validateClaimFreeService,
        payload,
        getToken()!
      );

      if (responseObject?.object.flag === true) {
        const isAnyItemInCart = showRemoveCart?.some(
          (cartItem: any) => cartItem.inCart === true
        );
        const isCurrentItemInCart = showRemoveCart?.find(
          (cartItem: any) => cartItem.id === item.id // Check if the clicked item is already in the cart
        );

        if (isAnyItemInCart && isCurrentItemInCart?.inCart === false) {
          console.log("Remove first service");
          // alert("You Can Claim Only One Service OR You Can Change Service");
          return;
        }
        // Update the inCart state
        const updatedItems = showRemoveCart?.map((currentItem: any) =>
          currentItem.id === item.id
            ? { ...currentItem, inCart: !currentItem.inCart } // Toggle inCart state
            : currentItem
        );
        // Update the cart service
        await addToCartService.addToCart(
          item.id,
          isCurrentItemInCart ? false : true,
          item.cid,
          item?.coverImage?.secureHttpPath,
          item?.aboutList,
          item?.subHeading,
          item?.serviceCharge,
          item?.productCost,
          item?.min,
          item?.specialPrice,
          item?.specialMessage
        );
        setShowRemoveCart(updatedItems);
        localStorage.setItem(
          "claimService",
          btoa(JSON.stringify(updatedItems))
        );
      } else {
        setShowClaimMessage(true);
      }
    } catch (error) {
      console.log("Error :", error);
    }
  };

  function handleUserLoggedIn() {
    localStorage.setItem("isAlreadyLogin", "true");
    Cookies.set("isAlreadyLogin", "true", {
      expires: 365,
      secure: true,
      sameSite: "Strict", // or 'Lax', depending on your use case
    });
    // setAlreadyLogin(true);
    window.location.reload();
  }

  const getClaimServices = useCallback(async () => {
    if (token) {
      try {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.claimServicesWithLogin,
            token,
            xHubId
          );
        setClaimData(responseObject?.object);
      } catch (error) {
        console.log("Error:", error);
      }
    }
    // else {
    //   try {
    //     const responseObject: ResponseObject | undefined =
    //       await apiService.get<ResponseObject>(
    //         apiService.claimServicesWithoutLogin,
    //         undefined,
    //         xHubId
    //       );
    //     setClaimData(responseObject?.object);
    //   } catch (error) {
    //     console.log("Error:", error);
    //   }
    // }
  }, [apiService, token, xHubId]);

  useEffect(() => {
    getClaimServices();
    setUpdateClaimService(false);
  }, [updateClaimService, getClaimServices]);

  return (
    <Box>
      <Grid item container xs={11.5} sm={11} md={9.5} lg={9.5} margin="auto">
        <Box
          sx={{
            textAlign: "center",
            flexDirection: "column",
            alignItems: "center",
            width: "100% ",
            marginTop: "1rem",
          }}
        >
          <Box sx={{ width: "100%", textAlign: "left" }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: "bold" }}
              className={claimData?.about ? "claim-service-heading" : ""}
            >
              {claimData?.about}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
              overflowX: "scroll",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none", // Hide scrollbar for Firefox
              msOverflowStyle: "none", // Hide scrollbar for IE/Edge
            }}
          >
            {claimData &&
              claimData?.servicesList?.map((item: any, index: number) => (
                <Box
                  key={index}
                  sx={{
                    minWidth: { xs: "9rem", sm: "11rem" },
                    minHeight: { xs: "9rem", sm: "11rem" },
                    width: { xs: "9rem", sm: "11rem" },
                    height: { xs: "9rem", sm: "11rem" },
                    borderRadius: "0.5rem",
                    overflow: "hidden",
                    position: "relative",
                    margin: {
                      xs: "0.5rem 0.5rem 0.5rem 0px",
                      sm: "1rem 1.5rem 1rem 0px",
                    },
                    boxShadow: "2px 2px 4px 2px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <Image
                    src={item?.coverImage?.secureHttpPath}
                    width={500}
                    height={500}
                    style={{
                      margin: "auto",
                      objectFit: "cover",
                      width: isSmallScreen ? "9rem" : "11rem",
                      height: isSmallScreen ? "9rem" : "11rem",
                      borderRadius: "0.5rem",
                      // background:
                      //   "linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))",
                    }}
                    alt="category"
                    // priority
                    decoding="async"
                    data-nimg="1"
                  />
                  <Box
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      height: "80%",
                      background:
                        "linear-gradient(to top, rgba(0, 0, 0, 0.7) 70%, rgb(255 255 255 / 0%))",
                    }}
                  >
                    <Box
                      sx={{
                        textAlign: "left",
                        padding: "8px",
                        bottom: 0,
                        position: "absolute",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ color: "white", marginBottom: "-4px" }}
                      >
                        {item?.name}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "white" }}>
                        {item?.subHeading}
                      </Typography>
                      <Typography variant="body2" sx={{ color: "white" }}>
                        FREE &nbsp;&nbsp;
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#b9b4b4",
                          }}
                        >
                          {currencyCode}
                          {item?.mrp}/-
                        </span>
                      </Typography>
                      <Box sx={{ width: "100%", textAlign: "right" }}>
                        {/* {item?.expireIn == null || undefined || 0 ? ( */}
                        {item?.claimExpire === true ? (
                          <button
                            // className="animated-button"
                            // onClick={() => handleTimer(index)}
                            style={{
                              color: "red",
                              background: "white",
                              borderRadius: "5px",
                              border: "none",
                              padding: "5px",
                              fontSize: "14px",
                              fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                              marginTop: "5px",
                            }}
                          >
                            Expired
                          </button>
                        ) : item?.expireIn > 0 ? (
                          <button
                            className={
                              showRemoveCart?.find(
                                (cartItem: any) =>
                                  cartItem.id === item.id &&
                                  cartItem.inCart == false
                              )
                                ? "animated-button-add-cart"
                                : ""
                            }
                            onClick={() => handleAddToCart(item)}
                            style={{
                              color: item?.addOn === false ? "white" : "red",
                              background: "black",
                              borderRadius: "5px",
                              border: "none",
                              padding: "5px",
                              fontSize: "12px",
                              fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                              cursor: "pointer",
                              marginTop: "5px",
                            }}
                          >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            {showRemoveCart?.find(
                              (cartItem: any) =>
                                cartItem.id === item.id &&
                                cartItem.inCart == false
                            )
                              ? "Add to Cart"
                              : "Remove"}
                          </button>
                        ) : (
                          <button
                            className="animated-button"
                            onClick={() => handleTimer(item, index)}
                            style={{
                              color: "#00fd00",
                              background: "black",
                              borderRadius: "5px",
                              border: "none",
                              padding: "5px",
                              fontSize: "14px",
                              fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                              cursor: "pointer",
                              marginTop: "5px",
                            }}
                          >
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                            Claim Now
                          </button>
                        )}

                        <Box sx={{ marginTop: "5px" }}>
                          {item?.expireIn == null || undefined || 0 ? (
                            ""
                          ) : (
                            <CountDown
                              offerTimerValid={false}
                              expireIn={item?.expireIn}
                            />
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              ))}
          </Box>
        </Box>
      </Grid>
      <Login
        showLoginBox={showLoginBox}
        handleLoginClose={() => setShowLoginBox(false)}
        handleUserLoggedIn={handleUserLoggedIn}
      />
      <ClaimServiceAlert
        openInfo={showClaimMessage}
        handleClose={() => setShowClaimMessage(false)}
      />
    </Box>
  );
};
